import { ReactNode, useState } from "react";
import { ScholarSidebar } from "./ScholarSidebar";
import { Button } from "@jambushrushti/components/ui/button";
import { Menu, X, Search, Home } from "lucide-react";
import { Input } from "@jambushrushti/components/ui/input";
import { Link } from "react-router-dom";
import { NotificationsPanel } from "./NotificationsPanel";

interface ScholarLayoutProps {
  children: ReactNode;
  title?: string;
}

export function ScholarLayout({ children, title }: ScholarLayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex min-h-screen" style={{ backgroundColor: "#FAF7F2" }}>
      {/* Desktop Sidebar */}
      <div className="hidden lg:block">
        <ScholarSidebar />
      </div>

      {/* Mobile Sidebar Overlay */}
      {sidebarOpen && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <div
            className="absolute inset-0 bg-black/50 backdrop-blur-sm"
            onClick={() => setSidebarOpen(false)}
          />
          <div className="animate-fade-in absolute left-0 top-0 h-full w-72">
            <ScholarSidebar onClose={() => setSidebarOpen(false)} />
          </div>
        </div>
      )}

      {/* Main Content */}
      <div className="flex min-h-screen w-full flex-1 flex-col">
        {/* Top Header */}
        <header
          className="sticky top-0 z-40 border-b"
          style={{ backgroundColor: "#FAF7F2", borderColor: "#E8E4DD" }}
        >
          <div className="flex h-14 items-center justify-between px-3 sm:h-16 sm:px-4 lg:px-6">
            <div className="flex items-center gap-2 sm:gap-4">
              <Button
                variant="ghost"
                size="icon"
                className="h-9 w-9 lg:hidden"
                onClick={() => setSidebarOpen(true)}
              >
                <Menu className="h-5 w-5" />
              </Button>
              {title && (
                <h1 className="font-heading truncate text-base font-semibold text-primary sm:text-xl">
                  {title}
                </h1>
              )}
            </div>

            <div className="flex items-center gap-2 sm:gap-3">
              {/* Search - Hidden on mobile */}
              <div className="relative hidden items-center md:flex">
                <Search className="absolute left-3 h-4 w-4 text-muted-foreground" />
                <Input
                  placeholder="Search..."
                  className="w-48 bg-background pl-9 lg:w-64"
                />
              </div>

              {/* Home Link */}
              <Button variant="ghost" size="icon" className="h-9 w-9" asChild>
                <Link to="/">
                  <Home className="h-5 w-5" />
                </Link>
              </Button>

              {/* Notifications */}
              <NotificationsPanel />
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 overflow-auto p-3 sm:p-4 lg:p-6">
          {children}
        </main>
      </div>
    </div>
  );
}
